import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import LoadingAnimation from './LoadingAnimation';
import Footer from './Footer';

const Reflection = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [reflection, setReflection] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReflection = async () => {
      try {
        const docSnap = await getDoc(doc(db, 'reflections', id));
        if (docSnap.exists()) {
          setReflection({ id: docSnap.id, ...docSnap.data() });
        } else {
          navigate('/reflections');
        }
      } catch (err) {
        console.error('Error fetching reflection:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchReflection();
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  const renderBlock = (block, index) => {
    switch (block.type) {
      case 'heading':
        return <h3 key={index} className="stt-article-heading">{block.content}</h3>;
      case 'image': {
        const size = block.size || 'medium';
        const align = block.align || 'center';
        const widths = { small: '25%', medium: '50%', large: '100%' };
        const justifyMap = { left: 'flex-start', center: 'center', right: 'flex-end' };
        return (
          <div
            key={index}
            className="stt-article-image"
            style={{ display: 'flex', justifyContent: size === 'large' ? 'center' : justifyMap[align] }}
          >
            <div style={{ width: widths[size] }}>
              <img src={block.url} alt={block.caption || ''} style={{ width: '100%', height: 'auto', display: 'block' }} />
              {block.caption && <p className="stt-article-caption">{block.caption}</p>}
            </div>
          </div>
        );
      }
      case 'text':
      default:
        return <p key={index} className="stt-article-paragraph">{block.content}</p>;
    }
  };

  if (loading) return <div className="stt-page"><LoadingAnimation /></div>;
  if (!reflection) return null;

  return (
    <div className="stt-page">
      <div className="stt-content">
        <div className="stt-article">
          <p style={{ marginBottom: '20px' }}>
            <a href="/reflections" className="stt-admin-back">← All Reflections</a>
          </p>

          {reflection.cover_image_url && (
            <img
              className="stt-article-cover"
              src={reflection.cover_image_url}
              alt={reflection.title}
            />
          )}

          <h1 className="stt-article-title">{reflection.title}</h1>
          <p className="stt-article-meta">
            {reflection.author && `By ${reflection.author}`}
            {reflection.author && reflection.created_at && ' · '}
            {formatDate(reflection.created_at)}
          </p>

          {(reflection.blocks || []).map((block, i) => renderBlock(block, i))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Reflection;
